import React, { Fragment, useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LineChats from './LineChats';
import TableData from './TableData';
import UserLableDatePickerFullTracking from './UserLableDatePickerFullTracking';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReportGenerate from '../layout/ReportGenerate';
import preloadimg from "../../assets/img/preloader1.gif";

export default function AlertDialog(props) {
  const [open, setOpen] = useState(false);
  const [isLoading, setisLoading] = useState(true);

  const baseurlFaqs = `${process.env.REACT_APP_SERVER_URL}/aipd/trackingByUser?email=${props.email}`;
  const [dataItems, setData] = useState();
  const [DataLoading, setDataLoading] = useState(true);
  
  const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];



  const GetTrakingData = async () => {
    console.log("count 1")
    try {
      const response = await fetch(baseurlFaqs, {
        headers: {
          Accept: "application/json",
          "oidc-token": passtoken,
        },
      });

      if (response.ok) {
        const jsonData = await response.json();
        // console.log(jsonData);
        setData(...jsonData);
        setDataLoading(false)
        setisLoading(false);
      } else {
        setData([]);
        setisLoading(false);
        
      }
    } catch (err) {
      console.error("Error:", err);
      setisLoading(false);
      setData([]);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
    GetTrakingData();

  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <div title="View" onClick={handleClickOpen}>
        <VisibilityIcon sx={{ color: "#0000a0" }} />
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="reportViewAnalytics"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {isLoading && (
              <div style={{height:"300px",textAlign:"center",alignContent:"center",alignItems:"center",display:"grid",gap:"1rem"}}>
                  <div> 
                    <img width={200} src={preloadimg} alt="Loading" />
                  </div>
                  <div>                  
                    Please wait, we are generating report for {props.email}
                  </div>
              </div>
            )}
            {!isLoading && (
              <>
                <div
                  style={{
                    display: "grid",
                    gridGap: "1rem",
                  }}
                >
                  <span style={{display:"flex",justifyContent:"space-between",alignContent:"center",alignItems:"center"}}>
                  <DialogTitle style={{padding:"0px"}} id="alert-dialog-title">
                    Reports for{" "}
                    <span
                      style={{
                        color: "#0000a0",
                        background: "#eee",
                        padding: "5px",
                        borderRadius: "6px",
                      }}
                    >
                      {props.email}
                    </span>
                  </DialogTitle>
                  <div>
                    <ReportGenerate
                      excelData={dataItems}
                      fileName={`${props.email}_${new Date().getTime()}`}
                    />
                  </div>
                  </span>

                  <div
                    style={{
                      boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
                      height: "400px",
                      padding: "1rem",
                      borderRadius: "6px",
                      width: "99%",
                      paddingBottom: "2rem",
                    }}
                  >
                    <LineChats dataLoading={DataLoading} jsonData={dataItems} />
                  </div>

                  <div
                    style={{
                      boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
                      height: "auto",
                      padding: "1rem",
                      borderRadius: "6px",
                      width: "99%",
                      paddingBottom: "2rem",
                    }}
                  >
                    <TableData dataLoading={DataLoading} data={dataItems} />
                  </div>

                  <div
                    style={{
                      boxShadow: "0px 0px 4px rgba(0,0,0,0.6)",
                      height: "auto",
                      borderRadius: "6px",
                      width: "99%",
                      paddingTop: "2rem",
                      margin: "auto",
                      display: "block",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                    }}
                  >
                    {/* <TableData dataLoading={DataLoading} data={dataItems} /> */}
                    <UserLableDatePickerFullTracking email={props.email} />
                  </div>
                </div>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={handleClose}>Disagree</Button>
          <Button onClick={handleClose} autoFocus>
            Agree
          </Button>
        </DialogActions> */}
      </Dialog>
    </Fragment>
  );
}
